var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPagetop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DB0013;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.42,
    cy: 42.36,
    r: 42.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,45.84v-2.72h10.61v2.72h-3.68V56.7h-3.26V45.84H23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.15,49.85c0-4.45,2.52-6.97,6.22-6.97s6.22,2.53,6.22,6.97c0,4.45-2.52,7.11-6.22,7.11 S36.15,54.3,36.15,49.85z M42.37,54.15c1.79,0,2.9-1.68,2.9-4.3c0-2.63-1.11-4.18-2.9-4.18s-2.88,1.55-2.88,4.18 C39.49,52.47,40.58,54.15,42.37,54.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.68,47.55c0,3.23-2.48,4.65-5.36,4.65h-1.59v4.5h-3.26V43.12h4.78C59.22,43.12,61.68,44.2,61.68,47.55z  M56.15,49.63c1.59,0,2.35-0.75,2.35-2.08c0-1.37-0.88-1.84-2.44-1.84h-1.33v3.92H56.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.68,31.2V20.27c0-0.42,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75V31.2c0,0.42-0.34,0.75-0.75,0.75 S41.68,31.61,41.68,31.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.46,24c0-0.19,0.07-0.38,0.22-0.53l4.22-4.22c0.29-0.29,0.76-0.29,1.05-0.01l4.34,4.22 c0.3,0.29,0.3,0.77,0.02,1.06c-0.29,0.3-0.77,0.3-1.06,0.02l-3.81-3.7l-3.7,3.7c-0.29,0.29-0.77,0.29-1.06,0 C37.53,24.38,37.46,24.19,37.46,24z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPagetop);
export default __webpack_public_path__ + "static/media/footer-pagetop.8b6b605df6d798598543e878fb08fd04.svg";
export { ForwardRef as ReactComponent };